import http from "@/http";
import store from "@/store";
import { getBrowser } from "@/tools";
import { databaseCleanup } from "@/services/database/DatabaseCleanup";
import { limparTodasPaginacoes } from "./modules/astec/utils/limparLocalStorage";

const buildDefaultHeaders = () => {
  const headers = {
    sistema: "Portal",
    plataforma: getBrowser()[0],
    versao: getBrowser()[1],
    ip: store.state.ip
  };

  if (window.latLng) {
    headers.lat = window.latLng.lat;
    headers.lng = window.latLng.lng;
  }

  return headers;
};

const login = async ({ commit }, user) => {
  const hasIdentifier = !!(user?.email || user?.cpf);
  const hasNewLoginPayload = !!(user?.challenge_id && user?.payload);

  if (!hasIdentifier) {
    throw new Error("Login inválido: informe e-mail ou CPF.");
  }

  if (!hasNewLoginPayload) {
    throw new Error("Login inválido");
  }

  const cpfLimpo = String(user?.cpf || "").replace(/\D/g, "");

  const dadosAutenticacao = {
    email: user?.email,
    cpf: cpfLimpo,
    challenge_id: user?.challenge_id,
    payload: user?.payload
  };

  try {
    const response = await http.post(
      "api/auth/autenticacao",
      dadosAutenticacao,
      {
        headers: buildDefaultHeaders()
      }
    );

    const responseData = response.data?.data || response.data;

    commit("DEFINIR_USUARIO_LOGADO", {
      access_token: responseData.access_token || responseData.AccessToken,
      user: responseData.user,
      me: responseData.me
    });

    commit("RESET_STATE");

    const responseroute = await http.get("api/portalmenu");
    const menuItems = processData(responseroute.data);

    commit("CRIA_MENU_ITEM", menuItems);

    return true;
  } catch (err) {
    throw err;
  }
};

const loginerp = ({ commit }, user) => {
  return new Promise((resolve, reject) => {
    let headers = buildDefaultHeaders();

    http
      .post(
        "api/auth/loginErp",
        {
          login: user.login,
          senha: user.senha
        },
        {
          headers
        }
      )
      .then(response => {
        if (response.data.me) {
          response.data.me.user_erp = true;
        }

        commit("DEFINIR_USUARIO_LOGADO", {
          access_token: response.data.access_token || null,
          user: response.data.user,
          me: response.data.me
        });

        commit("RESET_STATE");

        http
          .get("api/portalmenuErp")
          .then(responseroute => {
            let menuItems = processDataErp(responseroute.data);

            commit("CRIA_MENU_ITEM", menuItems);
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      })
      .catch(err => {
        reject(err);
      });
  });
};

const logout = ({ commit, dispatch }) => {
  return new Promise((resolve, reject) => {
    http
      .post("api/auth/logout")
      .then(async () => {
        try {
          await databaseCleanup.clearAll();
          console.log("✅ IndexedDB limpo no logout");
        } catch (error) {
          console.warn(
            "⚠️ Erro ao limpar IndexedDB, continuando logout...",
            error
          );
        }

        commit("DESLOGAR_USUARIO");
        dispatch("acompanhamentoMensal/clearCampanhaPendencia", null, {
          root: true
        });

        dispatch("astec/filtros/filtrosLotes/limparFiltros", null, {
          root: true
        });
        dispatch("astec/filtros/filtrosProjetos/limparFiltrosProjetos", null, {
          root: true
        });
        dispatch(
          "astec/filtros/filtrosClientesRurais/limparFiltrosClientesRurais",
          null,
          { root: true }
        );

        await dispatch(
          "astec/paginacao/paginacaoClienteRural/resetarPaginacao",
          null,
          { root: true }
        );
        await dispatch(
          "astec/paginacao/paginacaoProjetos/resetarPaginacao",
          null,
          { root: true }
        );
        await dispatch(
          "astec/paginacao/paginacaoProjetoPorLote/resetarPaginacao",
          null,
          { root: true }
        );

        limparTodasPaginacoes();
        localStorage.removeItem("rdv_mesReferencia");
        localStorage.removeItem("rdv_projeto");

        resolve();
      })
      .catch(async error => {
        console.log("Erro no logout:", error);

        try {
          await databaseCleanup.clearAll();
          console.log("IndexedDB limpo (logout com erro na API)");
        } catch (cleanupError) {
          console.warn("Erro ao limpar IndexedDB", cleanupError);
        }

        commit("DESLOGAR_USUARIO");
        dispatch("acompanhamentoMensal/clearCampanhaPendencia", null, {
          root: true
        });
        localStorage.removeItem("rdv_mesReferencia");
        localStorage.removeItem("rdv_projeto");

        reject();
      });
  });
};

function processData(data) {
  let objetoMenu = [];
  let itemMenu = null;

  if (data.length <= 0) {
    alert(
      "Perfil do usuário sem módulos no sistema, entre em contato com a Unicampo!"
    );
  }

  data.forEach(route => {
    if (typeof route.subItems !== "undefined") {
      itemMenu = processData(route.subItems);
      objetoMenu.push({
        id: route.id,
        label: route.label,
        subItems: itemMenu,
        isTitle: route.isTitle,
        icon: route.icon
      });
    } else {
      objetoMenu.push({
        id: route.id,
        label: route.label,
        link: route.link,
        parentId: route.parentId,
        isTitle: route.isTitle,
        icon: route.icon
      });
    }
  });

  return objetoMenu;
}

function processDataErp(data) {
  let objetoMenu = [];
  let itemMenu = null;

  if (data.length <= 0) {
    alert(
      "Perfil do usuário sem módulos no sistema, entre em contato com a Unicampo!"
    );
  }

  data.forEach(route => {
    if (typeof route.subItems !== "undefined") {
      itemMenu = processDataErp(route.subItems);
      objetoMenu.push({
        id: route.id,
        label: route.label,
        subItems: itemMenu,
        isTitle: route.isTitle,
        icon: route.icon
      });
    } else {
      objetoMenu.push({
        id: route.id,
        label: route.label,
        link: route.link,
        parentId: route.parentId,
        isTitle: route.isTitle,
        icon: route.icon
      });
    }
  });

  return objetoMenu;
}

const filtroTomador = ({ commit }, filtro) => {
  return new Promise((resolve, reject) => {
    if (filtro) {
      resolve(filtro);
      return;
    }

    http
      .get("api/tomador/filtrarProjetos")
      .then(response => {
        commit("FILTRO_TOMADOR", response.data);
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const setInfoBancaria = ({ commit }, statusInfoBancaria) => {
  commit("INFO_BANCARIA", statusInfoBancaria);
};

export { login, loginerp, logout, filtroTomador, setInfoBancaria };
